import React from "react";
import { ArrowLeft } from "lucide-react";

interface BackButtonProps {
  onClick?: () => void;
}

function BackButton({ onClick }: BackButtonProps) {
  const handleClick = () => {
    if (onClick) {
      onClick();
    }
  };

  return (
    <button
      className="inline-flex items-center gap-2 px-3 py-2 text-sm font-normal text-gray-600 hover:text-gray-900 hover:bg-gray-50 rounded-lg transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-gray-200"
      onClick={handleClick}
    >
      <ArrowLeft className="w-4 h-4" />
      <span>Back</span>
    </button>
  );
}

export default BackButton;
